/**
 * Swan account-country coverage (ISO 3166-1 alpha-2) — THE single source of truth.
 *
 * Swan opens accounts only for holders RESIDING in these countries (IBANs FR/BE/
 * DE/IT/NL/ES). This is the residence eligibility gate for "Open my account".
 *
 * ⚠️ This is the ONLY place this list lives. The Swan adapter derives its
 * account-country check from `isSwanAccountCountry` (no second hardcoded list).
 * To expand coverage (Swan adds a country, or we add another BaaS), edit THIS
 * array only — every gate (api + web) follows automatically.
 *
 * Gate is RESIDENCE, never nationality (FATCA nationality is collected for KYC
 * but is not used here).
 */
export const SWAN_ACCOUNT_COUNTRIES = ['FR', 'BE', 'DE', 'IT', 'NL', 'ES'];
const SET = new Set(SWAN_ACCOUNT_COUNTRIES);
/**
 * True if the alpha-2 residence country is eligible for a Swan account.
 * Normalises case/whitespace; null/undefined/unknown → false (→ waitlist, no crash).
 */
export function isSwanAccountCountry(alpha2) {
    if (!alpha2)
        return false;
    return SET.has(alpha2.trim().toUpperCase());
}
//# sourceMappingURL=swan-account-countries.js.map